import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import SHA256 from 'crypto-js/sha256';
import HmacSHA512 from 'crypto-js/hmac-sha512';
import Base64 from 'crypto-js/enc-base64';

export function encrypt(value: string, key: string): string {
  return AES.encrypt(value, key).toString();
}

export function decrypt(ciphertext: string, key: string): string {
  const bytes = AES.decrypt(ciphertext, key);
  return bytes.toString(Utf8);
}


export function obfuscateKey(logicalName: string, secret: string): string {
  return SHA256(logicalName + secret).toString();
}

export function hashSHA256(input: string) {
  return SHA256(input);
}


export function hmacSha512Base64(data: string, key: string): string {
  const hmac = HmacSHA512(data, key);
  return Base64.stringify(hmac);
}
